import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { authenticationService } from '../../services/auth.service';
import { UserRoleEnum } from '../../models/enums/UserRoleEnum';
import { normalizeAppPath } from '../../utils/slug';

interface ProtectedRouteProps {
  allowedRoles?: UserRoleEnum[];
  allowedModules?: string[];
}

const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { isAuthenticated } = useAuth();
  const { allowedRoles, allowedModules } = props

  if (isAuthenticated) {
    const user = authenticationService.currentUserValue;

    if (!allowedRoles && !allowedModules) {
      return <Navigate to="/nao-autorizado" replace />;
    }

    if (user) {
      const hasRequiredRole = allowedRoles ? authenticationService.hasAnyRole(allowedRoles) : false;
      const hasRequiredModule = allowedModules ? authenticationService.hasAnyModule(allowedModules) : false;
      const isAlwaysAllowed = allowedRoles?.includes(UserRoleEnum.ALWAYS_ALLOWED);

      if (allowedRoles && allowedModules) {
        // Both roles and modules specified: user must satisfy at least one
        if (!(hasRequiredRole || hasRequiredModule) && !isAlwaysAllowed) {
          return <Navigate to="/nao-autorizado" replace />
        }
      } else if (allowedRoles && !hasRequiredRole && !isAlwaysAllowed) {
        // Only roles specified
        return <Navigate to="/nao-autorizado" replace />
      } else if (allowedModules && !hasRequiredModule) {
        // Only modules specified
        return <Navigate to="/nao-autorizado" replace />
      }
    }
  }

  const redirectTo = encodeURIComponent(normalizeAppPath(window.location.pathname));

  return isAuthenticated ? <Outlet /> : <Navigate to={`/entrar?redirecionar=${redirectTo}`} />
};

export default ProtectedRoute;
